<template>
  <Dialog header="Création d'un groupe" :closeOnEscape="false" :dismissableMask="false" :closable="false" :modal="true" :visible.sync="displayModal" height="50px" width="50px">
    <p> Nom du groupe :</p>
    <InputText class="mt-5 input-create-group-input" type="text" aria-placeholder="nom du projet"
               v-model="group.title" @keydown.enter="createProjet" autofocus />
    <template #footer>
      <Button label="Annuler" @click="close" class="p-button-text"/>
      <Button class="buttonAddUser" label="Créer mon groupe" icon="" @click="createProjet" autofocus/>
    </template>
  </Dialog>
</template>

<script>
export default {
  data () {
    return {
      group: {
        title: null,
        project_id: null
      }
    }
  },

  props: {
    displayModal: Boolean
  },
  methods: {
    createProjet: function() {
        this.$store.dispatch('projects/createGroup', this.group).then((res) => {
          this.$emit('reloadProjet')
         this.close()
        })
    },
    close: function () {
      this.$emit('close')
    }
  },
  created() {
    this.group.project_id = this.$route.params.idProject
  }

}
</script>

<style>

</style>
